export enum LaunchPadFeatureSaaS {
  IntegrateVCS = "IntegrateVCS",
  IntegrateCloud = "IntegrateCloud",
  CreateStack = "CreateStack",
  InviteTeammates = "InviteTeammates",
}
